import { useCallback, useMemo } from 'react'

import { lastReadAtStorage } from '@/helpers/notificationReadState'

import { useLocalStorageItem } from './useLocalStorageItem'

interface UseNotificationReadStateResult {
    lastReadAt: Date | null
    markAllRead: () => void
}

export const useNotificationReadState = (source: string, userId: string): UseNotificationReadStateResult => {
    const storage = useMemo(() => lastReadAtStorage(source, userId), [source, userId])
    const [lastReadAt, setLastReadAt] = useLocalStorageItem(storage)

    const markAllRead = useCallback((): void => {
        setLastReadAt(new Date())
    }, [setLastReadAt])

    return { lastReadAt, markAllRead }
}
